module.exports = __webpack_public_path__ + "fonts/StagSans-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Light.ttf
// module id = 1085
// module chunks = 0